/** Shared folder users receive after submitting the opt-in form */
export const DRIVE_FOLDER_URL =
  'https://drive.google.com/drive/folders/16I13Iz32XCQBVVlxAruAlkzRFBLfIT7b';

export const books = [
  {
    id: 'ai-millionaire',
    title: 'AI Millionaire',
    subtitle: 'Build Real Generational Wealth with AI',
    description:
      'A bold, practical guide for hustlers, dreamers, and forward-thinkers ready to stake their claim in the AI-powered economy. A wake-up call — and a roadmap — for anyone who refuses to be left behind.',
    longDescription: `This isn't another "tech is coming" panic parade. This is about beating the system by learning how it works, and using AI as a tool to scale businesses, automate income, and build real generational wealth.

The book breaks down how anyone — with or without a tech background — can use AI tools to create businesses, automate work, sell services, and earn globally, right from where they are.`,
    highlights: [
      'The wealth mindset shifts that separate AI winners from the left-behind',
      'How to turn a single AI skill into a global, location-independent income',
      'Frameworks to automate work and scale without a technical background',
      'A step-by-step path from first naira to generational wealth',
    ],
    coverImage: '/images/ai-millionaire-cover.jpg',
    driveLink: 'https://drive.google.com/file/d/1b0Ba-Kuoc3InqSv_EzAm6hxJCPLaYFrJ/view',
    category: 'Business & Wealth',
    pages: '250+',
    readTime: '4–5 hrs',
    difficulty: 'Beginner to Advanced',
  },
  {
    id: 'ai-revolution',
    title: 'AI Revolution',
    subtitle: 'Navigate the Future of Work and Business',
    description:
      'A strategic guide for navigating the profound shifts brought by Artificial Intelligence — written for entrepreneurs, professionals, and visionaries who understand AI is a total reset of how we live and work.',
    longDescription: `Inside, you'll discover how to make your business AI-compliant, transform your profession into a modern AI-powered enterprise, and tap into emerging opportunities without being left behind. From practical tools and industry examples to ethical concerns and global implications, the book gives you the clarity, courage, and competence to thrive in this era.

AI Revolution is not about hype. It is about action. It equips you to lead change, protect your relevance, and create value in a world rapidly reshaped by intelligent technology.`,
    highlights: [
      'How to make any business AI-compliant and future-proof',
      'Transform your profession into a modern AI-powered enterprise',
      'The industries being reset — and where the new opportunities are',
      'A playbook to lead change instead of being replaced by it',
    ],
    coverImage: '/images/ai-revolution-cover.jpg',
    driveLink: 'https://drive.google.com/file/d/1b0Ba-Kuoc3InqSv_EzAm6hxJCGhaYFrJ/view',
    category: 'Technology & Innovation',
    pages: '300+',
    readTime: '5–6 hrs',
    difficulty: 'Intermediate to Advanced',
  },
  {
    id: 'ai-goldmine',
    title: 'AI Goldmine',
    subtitle: 'Turn AI into Daily Income and Business Growth',
    description:
      'A playbook for everyday people — especially Nigerians and Africans — ready to turn artificial intelligence into daily income, business growth, and long-term wealth. Written for hustlers, not tech experts.',
    longDescription: `This book breaks down how anyone — with or without a tech background — can use AI tools to create businesses, automate work, sell services, and earn globally, right from where they are. Whether you are a tailor in Ibadan, a coach in Nairobi, or a student in Port Harcourt, AI Goldmine shows you where to dig and how to build.

It is your practical guide to finding digital gold in a world that is being rewritten by code.`,
    highlights: [
      'Real, low-cost AI tools you can start earning with this week',
      'How local businesses and side-hustlers are cashing in on AI',
      'Sell services and earn globally — straight from your phone',
      'Where to "dig" for opportunity and how to build a system around it',
    ],
    coverImage: '/images/ai-goldmine-cover.jpg',
    driveLink: 'https://drive.google.com/file/d/1b0Ba-Kuoc3InqSv_EzAm6hxHYGhaYFrJ/view',
    category: 'Entrepreneurship',
    pages: '280+',
    readTime: '4–5 hrs',
    difficulty: 'All Levels',
  },
  {
    id: 'ai-for-pastors',
    title: 'AI for Pastors',
    subtitle: 'Ministry, Impact and Income with AI',
    description:
      'Not a book about technology — a book about transformation. A practical guide for spiritual leaders who want to remain relevant, reach more souls, and run more effective ministries in the age of AI.',
    longDescription: `This book equips pastors, church founders, ministry workers, and Christian creatives with the tools to use AI without compromising their calling. From sermon preparation to digital evangelism, content creation to community management, AI is not here to replace the pastor — it is here to empower the mission.

The future of the Church will not be built on tradition alone. It will be built by leaders who can blend timeless truth with timely tools.`,
    highlights: [
      'Use AI for sermon prep, study and content — without losing your voice',
      'Digital evangelism strategies to reach more souls online',
      'Automate church admin and community management wisely',
      'Steward your time and expand your influence in the digital age',
    ],
    coverImage: '/images/ai-pastors-cover.jpg',
    driveLink: 'https://drive.google.com/file/d/1b0Ba-Kuoc3InqSv_PvAm6hxHYGhaYFrJ/view',
    category: 'Ministry & Leadership',
    pages: '220+',
    readTime: '3–4 hrs',
    difficulty: 'All Levels',
  },
  {
    id: 'ai-money-machines',
    title: 'AI Money Machines',
    subtitle: 'Turn AI Into Daily Income, Wealth & Legacy',
    description:
      'Your no-fluff, street-smart guide to unlocking real income opportunities with tools once reserved for tech elites — for entrepreneurs, students, creators, and legacy business owners.',
    longDescription: `This book shows you how to turn free and low-cost AI tools into profitable ventures that work for you — from your smartphone, your shop, or your laptop.

Whether you're trying to escape a 9–5, scale a side hustle, or bring your family business into the future, AI Money Machines hands you the strategies, tools, and case studies to make it happen.`,
    highlights: [
      'Build "money machines" that earn from your phone, shop or laptop',
      'Free and low-cost AI tools turned into profitable ventures',
      'Real case studies you can model and adapt to your market',
      'A path to escape the 9–5 or scale the side hustle you already run',
    ],
    coverImage: '/images/ai-money-machine.jpg',
    driveLink:
      'https://drive.google.com/file/d/10WRwPL7CZAdicqfWz84H_9CokuOG50B7/view?usp=sharing',
    category: 'Finance & Wealth',
    pages: '200+',
    readTime: '3–4 hrs',
    difficulty: 'All Levels',
  },
];

/** Author authority block */
export const AUTHOR = {
  name: 'Dr. Stephen Akintayo',
  title: 'Investment Coach · Serial Entrepreneur · Bestselling Author',
  monogram: 'SA',
  bio: [
    'Dr. Stephen Akintayo is one of Africa’s most influential investment coaches and the chairman of GText Holdings, a global conglomerate spanning real estate, agriculture, technology and media across multiple continents.',
    'Through his books, masterclasses and mentorship, he has guided hundreds of thousands of entrepreneurs to build businesses, create income and secure their financial future. This library distills his frameworks for the AI era into five practical playbooks — free.',
  ],
  credentials: [
    'Chairman, GText Holdings',
    'Author of 40+ books on wealth & business',
    'Trained 500,000+ entrepreneurs',
    'Featured across major African media',
  ],
};

/** Aggregate proof stats */
export const STATS = [
  { number: '5', label: 'Complete Playbooks' },
  { number: '1,250+', label: 'Pages of Strategy' },
  { number: '25,000+', label: 'Readers & Counting' },
  { number: '100%', label: 'Free — No Cost' },
];

/** Social proof */
export const TESTIMONIALS = [
  {
    quote:
      'I read AI Goldmine in a weekend and landed my first paying client that same week using tools I never knew existed. This isn’t theory — it’s a step-by-step map.',
    name: 'Chidinma O.',
    role: 'Freelance Content Strategist · Lagos',
  },
  {
    quote:
      'As a pastor I was skeptical. AI for Pastors showed me how to prepare, reach more people online and reclaim hours every week — without compromising the message.',
    name: 'Pastor Emmanuel A.',
    role: 'Church Founder · Abuja',
  },
  {
    quote:
      'The frameworks in AI Millionaire completely changed how I think about income. I now run two automated income streams from my laptop. Worth far more than free.',
    name: 'Tunde B.',
    role: 'Small Business Owner · Ibadan',
  },
];

/** Objection-handling FAQ */
export const FAQS = [
  {
    q: 'Are these books really free?',
    a: 'Yes — completely free. Enter your details and you’ll get instant access to the full folder of all five books. No payment, no credit card, no catch.',
  },
  {
    q: 'Do I need any tech or coding background?',
    a: 'Not at all. Every book is written in plain language for hustlers, professionals, students and business owners. If you can use a smartphone, you can apply what’s inside.',
  },
  {
    q: 'How do I receive the books after signing up?',
    a: 'The moment you submit the form, a secure Google Drive folder opens with all five books ready to read or download on any device — phone, tablet or laptop.',
  },
  {
    q: 'Will you spam my email?',
    a: 'No. We’ll occasionally share genuinely useful AI and business insights, and you can unsubscribe with one click anytime. Your details are never sold.',
  },
  {
    q: 'Which book should I start with?',
    a: 'Start with the one that matches your goal — wealth-building, ministry, or turning AI into daily income. You get all five, so you can read them in any order.',
  },
];

export const getBookById = (id) => books.find((book) => book.id === id);
